export default __webpack_public_path__ + "static/media/taiko.a6720e2c.svg";